import { Box, TableCell, TableRow } from '@/shared/ui';

import type { SymbolKey } from '@/entities/symbol';
import type { FactsheetSymbol } from '@/features/factsheet';
import { useFactsheetSelection } from '@/features/factsheet/state/FactsheetSelectionContext';
import CustomCheckbox from '@/shared/ui/primitives/Checkbox';

const ItemsTableRow = ({ symbol, code }: { symbol: FactsheetSymbol; code: string }) => {
  const selection = useFactsheetSelection();
  const isSymbolSelected = selection?.isSymbolSelected ?? (() => false);
  const toggleSymbolInSelection = selection?.toggleSymbolInSelection ?? (() => {});
  const isSpotLocked = selection?.isSpotLocked ?? false;
  const { timeRef, period, periodType, alias, timeRefDetail } = symbol;
  const selectedSymbol: SymbolKey = {
    Code: code,
    Period: period,
    PeriodType: periodType,
    TimeRef: timeRef
  };
  const itemKey = code + timeRef + period + periodType;

  return (
    <TableRow
      key={itemKey}
      sx={{
        '&:last-child td, &:last-child th': { pb: 1 },
        '&:first-of-type td, &:first-of-type th': { pt: 1 }
      }}
    >
      <TableCell
        sx={{
          p: 0,
          pl: 1,
          pr: 1,
          borderLeft: 'none'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <CustomCheckbox
            checked={isSymbolSelected(selectedSymbol)}
            modeLocked={isSpotLocked}
            onLockedClick={() => {
              toggleSymbolInSelection(selectedSymbol);
            }}
            onChange={() => {
              toggleSymbolInSelection(selectedSymbol);
            }}
          />
        </Box>
      </TableCell>
      <TableCell
        component='th'
        scope='row'
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        {code}
      </TableCell>
      <TableCell>{timeRef}</TableCell>
      <TableCell>{periodType}</TableCell>
      <TableCell>{period}</TableCell>
      <TableCell sx={{ width: '20%' }}>{alias}</TableCell>
      <TableCell sx={{ width: '20%' }}>{timeRefDetail}</TableCell>
    </TableRow>
  );
};
export default ItemsTableRow;
